import { AppState } from '../../interfaces';
import { connect } from 'react-redux';
import LanguageSelect from './LanguageSelect';
import { getPreferences, setPreferences, getChallenges } from '../../actions/rewardProgram';
import { actionsSavingEngine } from '../../actions/qaIndex';
import { locationConfig } from '../../actions/index';

const mapStateToProps = (state: AppState) => ({
  app: state.appReducer,
  status: state.translationReducer.status,
  appWidth: state.uiReducer.appWidth,
  page: state.preferencesReducer,
});

const mapDispatchToProps = dispatch => ({
  getPreferences: () => dispatch(getPreferences()),
  setPreferences: (data, callBack) => dispatch(setPreferences(data, callBack)),
  getLocation: postcode => dispatch(locationConfig(postcode)),
  getQuestions: (waterClient: string) => dispatch(actionsSavingEngine.getQuestions(waterClient)),
  getChallenges: () => dispatch(getChallenges()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
